import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { redirectToNewZing, shouldRedirectToNewZing } from '../utils/new-zing-redirect';

// Phase 4: every top-level classic-Zing entry (dashboard, shipping, marketplace, etc.)
// is unconditionally redirected to New Zing, not just after a fresh login. Works
// alongside the callback redirect so bookmarks and direct navigation also land in New Zing.
//
// Classic Zing pages are embedded in iframes inside New Zing; an embedded frame must
// never redirect itself, so the guard passes through when not running top-level.
export const newZingOptInRedirectGuard: CanActivateFn = (route, state) => {
  const doc = inject(DOCUMENT);
  const win = doc.defaultView;

  if (win && win.self !== win.top) {
    return true; // embedded in New Zing: never self-redirect
  }

  // Stay in classic Zing when there is no New Zing deployment to hand off to
  // (uat, training, where betaExperienceUrl is empty and redirecting would loop),
  // or when an automated test has set the force-classic cookie on a lower environment.
  if (!shouldRedirectToNewZing(doc)) {
    return true;
  }

  // Preserve the attempted deep link, matching the callback redirect behavior. If the
  // callback already handed off (postLoginRoute after a login), this is a no-op so the
  // callback's deep link is not replaced.
  redirectToNewZing(doc, state.url || '/dashboard');
  return false;
};
